module.exports = __webpack_public_path__ + "img/av232.710aec4d.png";